import React from 'react';

import { User } from 'api/objectDocs/type';

interface AddedByCellProps {
  data: User | null;
}

const AddedByCell: React.FC<AddedByCellProps> = ({ data }) => {
  return data ? (
    <a href={`${process.env.REACT_APP_BASE_DJANGO_URL}/user/${data.slug}/detail`}>
      <div className="d-flex align-items-center">
        <div>{data.username}</div>
        <div className="avatar-xxs mx-3">
          <img className="img-fluid rounded-circle" src={data.image} alt={data.username} />
        </div>
      </div>
    </a>
  ) : (
    <div>-</div>
  );
};

export default AddedByCell;
